export interface BuiltInModel {
  nodeDefinitionId: string;
}

export interface BuiltInModelResponse {
  builtInModel: BuiltInModel;
}

export const isBuiltInModelResponse = (response: object): response is BuiltInModelResponse =>
  'builtInModel' in response;
